/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Status_RemovedInputs */

const id_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dihapus`)
};

const ms_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuang`)
};

const da_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjernet`)
};

const de_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernt`)
};

const en_us2_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removed`)
};

const es_es2_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado`)
};

const es_mx2_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado`)
};

const fil_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inalis`)
};

const fr_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimé`)
};

const it_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimosso`)
};

const hu_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltávolítva`)
};

const nl_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderd`)
};

const no_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjernet`)
};

const pl_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunięte`)
};

const pt_br2_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removido`)
};

const pt_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removido`)
};

const ro_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminat`)
};

const fi_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poistettu`)
};

const sv_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borttagen`)
};

const vi_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xóa`)
};

const tr_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaldırıldı`)
};

const cs_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebrané`)
};

const bg_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премахнати`)
};

const ru_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалено`)
};

const uk_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вилучено`)
};

const ar_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محذوف`)
};

const hi_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाए गए`)
};

const th_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบแล้ว`)
};

const ja_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_cn2_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已移除`)
};

const zh_hant1_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已移除`)
};

const ko_builds_comparison_status_removed = /** @type {(inputs: Builds_Comparison_Status_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삭제됨`)
};

/**
* | output |
* | --- |
* | "Removed" |
*
* @param {Builds_Comparison_Status_RemovedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_status_removed = /** @type {((inputs?: Builds_Comparison_Status_RemovedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Status_RemovedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_status_removed(inputs)
	if (locale === "ms") return ms_builds_comparison_status_removed(inputs)
	if (locale === "da") return da_builds_comparison_status_removed(inputs)
	if (locale === "de") return de_builds_comparison_status_removed(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_status_removed(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_status_removed(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_status_removed(inputs)
	if (locale === "fil") return fil_builds_comparison_status_removed(inputs)
	if (locale === "fr") return fr_builds_comparison_status_removed(inputs)
	if (locale === "it") return it_builds_comparison_status_removed(inputs)
	if (locale === "hu") return hu_builds_comparison_status_removed(inputs)
	if (locale === "nl") return nl_builds_comparison_status_removed(inputs)
	if (locale === "no") return no_builds_comparison_status_removed(inputs)
	if (locale === "pl") return pl_builds_comparison_status_removed(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_status_removed(inputs)
	if (locale === "pt") return pt_builds_comparison_status_removed(inputs)
	if (locale === "ro") return ro_builds_comparison_status_removed(inputs)
	if (locale === "fi") return fi_builds_comparison_status_removed(inputs)
	if (locale === "sv") return sv_builds_comparison_status_removed(inputs)
	if (locale === "vi") return vi_builds_comparison_status_removed(inputs)
	if (locale === "tr") return tr_builds_comparison_status_removed(inputs)
	if (locale === "cs") return cs_builds_comparison_status_removed(inputs)
	if (locale === "bg") return bg_builds_comparison_status_removed(inputs)
	if (locale === "ru") return ru_builds_comparison_status_removed(inputs)
	if (locale === "uk") return uk_builds_comparison_status_removed(inputs)
	if (locale === "ar") return ar_builds_comparison_status_removed(inputs)
	if (locale === "hi") return hi_builds_comparison_status_removed(inputs)
	if (locale === "th") return th_builds_comparison_status_removed(inputs)
	if (locale === "ja") return ja_builds_comparison_status_removed(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_status_removed(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_status_removed(inputs)
	return ko_builds_comparison_status_removed(inputs)
});
export { builds_comparison_status_removed as "builds.comparison.status.removed" }